<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitre }}
              </h1>
              <app-breadcrumb v-if="idRemiseBancaire" :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <b-checkbox class="mgr-10px" v-model="addOther" v-if="!isModification">
              {{$t('remiseBancaire.ajoutReglement.ajouterUnAutre')}}
            </b-checkbox>
            <a class="button" @click="annuler">
              {{$t('remiseBancaire.ajoutReglement.annuler')}}
            </a>
            <a class="button is-addOrEdit" @click="sauvegardeReglement()">
              {{$t('general.button.sauvegarder')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component :messages="messages"
                          :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'remiseBancaire.errors.problemOccurred'"
                          :withEmplyFields="true"
                          @close="error = $event"/>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('remiseBancaire.ajoutReglement.informationRemiseBancaire') }}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <b-field :label="$t('remiseBancaire.ajoutReglement.banque')"
                   class="column is-4" v-if="remiseBancaire.domiciliationBancaire">
            <p>{{ remiseBancaire.domiciliationBancaire.libelleBanque }}
              ({{ remiseBancaire.domiciliationBancaire.libelle }})</p>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.modeReglement:')"
                   class="column is-4" v-if="remiseBancaire.modeReglement">
            <p>{{ remiseBancaire.modeReglement.libelle }}</p>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{getSousTitre}}</p>
      </header>
      <div class="card-content">
        <b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.clientOuCompteComptable')"
                   class="column is-5">
            <b-autocomplete icon="magnify"
                            v-model="infoClient.client"
                            field="nomCommercialAvecVille"
                            :data="infoClient.dataAutoComplete"
                            @input="getClientASyncAndReloadFacture()"
                            @select="item => selectClient(item)"
                            :disabled="isModification">
                <template slot-scope="props">
                  <div>
                    {{ props.option.nomCommercialAvecVille }}
                  </div>
                  <div>
                    {{ props.option.nomJuridique }}
                  </div>
                </template>
            </b-autocomplete>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.numeroFacture')"
                   class="column is-3">
            <b-autocomplete icon="magnify"
                            v-model="infoFacture.facture"
                            field="codeAnnonceur"
                            :data="dataFacture"
                            @input="getFactureASyncAndReloadClient()"
                            @select="item => selectFacture(item)"
                            :disabled="isModification">
            </b-autocomplete>
          </b-field>
        </b-field>
        <b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.dateReglement')"
                   class="column obligatoire is-3">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today"
              v-model="dateReglementTmp"
              :editable="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.montantTtc')"
                   class="obligatoire column">
            <input-currency :value="mouvementClientReglement.credit"
                            @input="checkMontantTtc"
                            isNumber="true"
                            :disabled="remiseValidee">
            </input-currency>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.dateEffet')"
                   class="column is-2">
            <b-datepicker show-week-number
              icon="calendar-today"
              nearby-selectable-month-days
              v-model="dateEffetTmp"
              :editable="true">
            </b-datepicker>
          </b-field>
           <b-field :label="$t('remiseBancaire.ajoutReglement.nomTire')"
                   class="column is-3">
            <b-input v-model="mouvementClientReglement.ligneRemiseBancairePseudoEntity.emetteur">
            </b-input>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.referenceTire')"
                   class="column">
            <b-input
              v-model="mouvementClientReglement.ligneRemiseBancairePseudoEntity.referenceReglement">
              </b-input>
          </b-field>
        </b-field>
      </div>
    </div>
    <div class="card mgt-20px" v-if="!isModification">
          <header class="header-card">
            <p>{{ $t('remiseBancaire.ajoutReglementPiece.creditDispo') }}</p>
          </header>
          <div class="card-content">
            <div v-if="existResteParPieceAuCredit" class="columns">
              <a class="card-header-icon mgr-5px pdr-0 height-30 column is-narrow"
                @click="otherCreditOpen = !otherCreditOpen ">
                <b-icon :icon="otherCreditOpen ? 'chevron-down' : 'chevron-right'"></b-icon>
              </a>
              <span class="has-text-default column is-narrow">
                {{$t('remiseBancaire.ajoutReglementPiece.autresCredits') }}
              </span>
              <span v-for="(reste, $index) in resteParPieceAuCredit"
                :key="$index"
                class="has-text-default column is-narrow has-text-weight-bold">
                <span>{{reste.pieceType}}</span>
                <span>
                  (<span class="has-text-warning">
                    {{ reste.restantALettrerTtc | formatDevise}}
                  </span>)
                </span>
              </span>
              <span class="column"></span>
              <span v-if="existResteParPieceSelectedAuCredit"
                class="column is-narrow columns is-marginless is-paddingless">
                <span class="has-text-default column is-narrow" >
                  {{$t('remiseBancaire.ajoutReglementPiece.autresCreditsSelected') }}
                </span>
                <span v-for="(creditSelected, $index) in selectedParPieceAuCredit"
                  :key="$index"
                  class="has-text-default column is-narrow has-text-weight-bold">
                  <span>{{creditSelected.pieceType}}</span>
                  <span>
                    (<span class="has-text-primary">
                      {{ creditSelected.restantALettrerTtc | formatDevise}}
                    </span>)
                  </span>
                </span>
              </span>
            </div>
            <div v-else>
              {{ $t('remiseBancaire.ajoutReglementPiece.aucunCredit')}}
            </div>
            <b-table :data="pieceAuCredit" :bordered="true" :striped="true"
              :sticky-header="atLeast5PieceAuCredit()"
              v-if="otherCreditOpen">
              <b-table-column field="selected" cell-class="colonneSelected"
                v-slot="props">
                <b-checkbox v-if="props.row.selected !== undefined"
                        v-model="props.row.selected"
                        :disabled="isModification"
                        @input="selectCredit()">
                </b-checkbox>
              </b-table-column>
              <b-table-column field="facture"
                              v-slot="props"
                              :label="$t('remiseBancaire.ajoutReglementPiece.referencePiece')">
                <router-link-blank v-if="pieceAsLink(props.row)"
                  :to="getUrlPiece(props.row)"
                  :message="props.row.referencePiece"
                /> <span v-else>{{props.row.referencePiece}}</span>
              </b-table-column>
              <b-table-column field="type"
                              v-slot="props"
                              :label="$t('remiseBancaire.ajoutReglementPiece.typePiece')">
                  <span>{{ props.row.pieceType }}</span>
              </b-table-column>
              <b-table-column field="dateEcheance"
                              v-slot="props"
                              :label="$t('remiseBancaire.ajoutReglementPiece.datePiece')">
                <span>{{props.row.datePiece | formatDate}}</span>
              </b-table-column>
              <b-table-column field="montant"
                              v-slot="props"
                              :label="$t('remiseBancaire.ajoutReglementPiece.totalPiece')"
                              cell-class="right">
                <span>{{props.row.montantPieceTtc | formatDevise}}</span>
              </b-table-column>
              <b-table-column field="montant"
                              v-slot="props"
                              :label="$t('remiseBancaire.ajoutReglementPiece.restantPiece')"
                              cell-class="right">
                <span>{{props.row.restantALettrerTtc | formatDevise}}</span>
              </b-table-column>
            </b-table>
          </div>
        </div>
    <div v-if="dataTable.length > 0" class="mgt-20px">
      <div class="columns mgt-20px">
        <div class="column is-3">
          <div class="card">
            <div class="card-content pd-10px">
              <p class="has-text-default"> {{$t('remiseBancaire.ajoutReglementPiece.soldeDe',
                { client: nomClient() }) }}</p>
              <router-link
                :target="checkPermissions(this.permsTiers.lecture) ? '_blank' : ''"
                :to="{
                  name: 'c.bodac.clients/contacts-enCours',
                  params:{ id: mouvementClientReglement.tiersId }
                  }"
                :class="{ 'text-access-no-permission': !checkPermissions(this.permsTiers.lecture)}">
                <div class="level">
                  <div class="level-left">&nbsp;
                  </div>
                  <div class="level-right has-text-weight-bold" :class="getColorOfSolde">
                    {{ soldeTiersId | formatDevise }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="column is-9">
          <div class="level-right columns">
            <div class="column is-3 is-3-fullhd">
              <div class="card">
                <div class="card-content pd-10px">
                  <p class="has-text-default">
                    {{$t('remiseBancaire.ajoutReglementPiece.cumulDesReglement') }}</p>
                  <div class="level">
                    <div class="level-left">
                      <b-icon icon="" class=""></b-icon>
                    </div>
                    <div class="level-right">
                      <span class="mgl-30px has-text-weight-bold">
                        {{ cumulDesReglements | formatDevise }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 is-2-fullhd">
              <div class="card">
                <div class="card-content pd-10px">
                  <p class="has-text-default">
                    {{$t('remiseBancaire.ajoutReglementPiece.affectation') }}</p>
                  <div class="level">
                    <div class="level-left">
                      <b-icon :icon="getIcon" class="" :type="getType"></b-icon>
                    </div>
                    <div class="level-right">
                      <span :class="getClassColor" class="mgl-30px has-text-weight-bold">
                        {{ this.totalLetterage | formatDevise }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 is-2-fullhd">
              <div class="card">
                <div class="card-content pd-10px">
                  <p class="has-text-default">
                    {{$t('remiseBancaire.ajoutReglementPiece.resteAAfeecter') }}</p>
                  <div class="level">
                    <div class="level-left">
                      <b-icon :icon="getIcon" class="" :type="getType"></b-icon>
                    </div>
                    <div class="level-right">
                      <span :class="getClassColor" class="mgl-30px has-text-weight-bold">
                        {{ getDifference | formatDevise }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-table :data="dataTable" :bordered="true" :striped="true">
        <b-table-column field="facture"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.referencePiece')">
          <router-link-blank v-if="pieceAsLink(props.row)"
            :to="getUrlPiece(props.row)"
            :message="props.row.referencePiece"
          /> <span v-else>{{props.row.referencePiece}}</span>
        </b-table-column>
        <b-table-column field="type"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.typePiece')">
            <span>{{ props.row.pieceType }}</span>
        </b-table-column>
        <b-table-column field="dateEcheance"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.datePiece')">
          <span>{{props.row.datePiece | formatDate}}</span>
        </b-table-column>
        <b-table-column field="montant"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.totalPiece')"
                        cell-class="right">
          <span>{{props.row.montantPieceTtc | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="montantRestant"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.restantPiece')"
                        cell-class="right">
          <span>
            {{props.row.restantALettrerTtc | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="escompte"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.escompte')"
                        class="has-text-right">
          <div class="columns is-vcentered">
            <div class="column is-10">
              <input-currency v-model="props.row.montantEscompte" :value="props.row.montantEscompte"
                            isNumber="true" @input="gererSaisieEscompte(props.row)"
                            :disabled="!isFacture(props.row)">
              </input-currency>
            </div>
            <div class="column is-2">
              <b-checkbox class='mgt-5px'
                v-model="props.row.escompteApplicable"
                :value="props.row.escompteApplicable"
                type="is-primary" @input="gererSaisieEscompte(props.row)"
                :disabled="!isFacture(props.row)">
              </b-checkbox>
            </div>
          </div>
        </b-table-column>
        <b-table-column field="affecter"
                        v-slot="props">
          <b-field position="is-right">
            <div @click="assignAmount(props.row)">
              <b-icon icon="arrow-expand-right" type="is-primary"
                      class="is-cursor-pointer mgt-5px"></b-icon>
            </div>
          </b-field>
        </b-table-column>
        <b-table-column field="inputAffecte"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.inputAffecte')">
          <input-currency v-model="props.row.inputAffecte" :value="props.row.inputAffecte"
                          isNumber="true" @input="calculateSolde(props.row)">
          </input-currency>
        </b-table-column>
        <b-table-column field="detail"
                        v-slot="props">
          <div @click="showPopupDetail(props.row)">
            <b-icon icon="table-search" type="is-primary"
                    class="is-cursor-pointer mgt-5px"></b-icon>
          </div>
        </b-table-column>
        <b-table-column field="solde"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.soldePiece')"
                        cell-class="right">
          <span>{{getSoldePiece(props.row) | formatDevise}}</span>
        </b-table-column>
      </b-table>

      <b-modal v-model="displayPopupDetail"
        has-modal-card
        class="modal" width="1280px">
        <popup-detail-piece :piece="piecePourDetail" />
      </b-modal>
    </div>
  </div>

</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import {
  ETAT_ENREGISTRE, SOUS_TYPE_NORMAL, SOUS_TYPE_ACOMPTE, TYPE_FACTURE, SENS_VENTE,
} from '@/configuration/devisConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import inputCurrency from '@/components/general/inputCurrency';
import validationReglement from '@/services/reglement/validation/validationReglement';
import breadcrumb from '@/components/general/breadcrumb';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { sauvegarde } from '@/api/lettrage/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { get as getMouvementClient, getSolde, getAllByPiece } from '@/api/mouvementClient/index';
import { getAll as getAllFacture } from '@/api/facture/index';
import { get as getRemiseBancaire } from '@/api/remiseBancaire/index';
import {
  get as getReglement, create as createReglement, update as updateReglement,
} from '@/api/reglement/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import miseEnFormeAddresseClient from '@/services/reglement/miseEnFormeAddresseClient';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import calculArrondi from '@/services/calcul/calculArrondi';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import formatDate from '@/services/general/formatDate';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import * as remiseConf from '@/configuration/remiseBancaire/remiseBancaireConf';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import messageInfo from '@/services/general/messageInformation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/reglement/validation/champsReglementTranslator';
import { INFINITE_DAY } from '@/configuration/general';
import { TIERS } from '@/configuration/permissionsBodacConf';
import preparationListePieces from '@/services/remiseBancaire/reglement/preparationListePieces';
import ventilationAutomatique from '@/services/remiseBancaire/reglement/ventilationAutomatique';
import gestionLettrages from '@/services/remiseBancaire/reglement/gestionLettrages';
import getEmptyMouvementClient from '@/services/remiseBancaire/reglement/getEmptyMouvementClient';
import genererRemiseBancaire from '@/services/remiseBancaire/genererRemiseBancaire';
import popupDetailPiece from '@/components/bodac/remiseBancaire/edit/popupDetailPiece';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import decimalsFormater from '@/services/general/decimalsFormater';

const societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'reglementPiece',
  data() {
    return {
      dataTable: [],
      addOther: true,
      infoClient: {
        client: '',
        clientSelected: null,
        dataAutoComplete: [],
      },
      infoFacture: {
        facture: '',
        factureSelected: null,
      },
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      dateReglementTmp: null,
      dateEffetTmp: null,
      error: false,
      tiersId: null,
      totalLetterage: 0,
      mouvement: [],
      dataFacture: [],
      remiseBancaire: genererRemiseBancaire(),
      mouvementClientReglement: getEmptyMouvementClient(),
      idRemiseBancaire: null,
      idReglement: null,
      reglementIsSave: null,
      soldeTiersId: null,
      montantReglementInitial: null,
      displayPopupDetail: false,
      piecePourDetail: null,
      pieceAuCredit: [],
      otherCreditOpen: false,
      resteParPieceAuCredit: [],
      selectedParPieceAuCredit: [],
      permsTiers: TIERS,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    routerLinkBlank,
    inputCurrency,
    errorMsgComponent,
    popupDetailPiece,
  },
  methods: {
    checkMontantTtc(newMontant) {
      this.mouvementClientReglement.credit = Number(decimalsFormater(newMontant));
      this.mouvementClientReglement.resteALettrer = this.mouvementClientReglement.credit
        - this.totalLetterage;
      if (!this.isModification || newMontant >= this.totalLetterage) {
        return;
      }
      this.dataTable.forEach((ligne) => {
        ligne.inputAffecte = 0;
        this.calculateSolde(ligne);
      });
      messageInfo(this.$i18n.t('remiseBancaire.ajoutReglement.info.montantTtcChange'));
    },
    getTiersId(client, facture) {
      if (client === null && facture === null) return null;
      if (facture === null) return client.id;
      let tiersId = null;
      facture.intervenants.forEach((intervenant) => {
        if (intervenant.payeur === true) tiersId = intervenant.tiersId;
      });
      return tiersId;
    },
    async getSoldeOfTiersId() {
      const param = {
        tiersId: this.mouvementClientReglement.tiersId,
        date: formatIsoDate(INFINITE_DAY),
      };
      this.soldeTiersId = (await getSolde(param)).data.result;
    },
    getClientASyncAndReloadFacture: debounce(async function loadData() {
      this.infoFacture.facture = '';
      if ((this.infoClient.clientSelected
        && this.infoClient.clientSelected.nomCommercialAvecVille === this.infoClient.client)
        || this.isModification) {
        return;
      }
      this.totalLetterage = 0;
      this.infoFacture.factureSelected = null;
      this.mouvement = [];
      this.dataTable = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.infoClient.client.length > 0) {
          const query = {
            query: {
              nomCommercialCompteComptableJuridique: this.infoClient.client,
              societeId: this.societeActiveId,
              type: tiersConf.TIERS_TYPE_CLIENT,
              sousType: [tiersConf.TIERS_SOUS_TYPE_AUCUN],
            },
          };
          const dataClient = await getAllTiers(query);
          await this.modificationAutoComplete(dataClient.data.result);
        }
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      this.infoClient.clientSelected = null;
    }, 500),
    async selectClient(client) {
      if (client === null) return;
      this.infoClient.clientSelected = client;
      const parameters = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        brouillard: false,
        tiersId: await this.getTiersId(client, null),
        societeId: this.societeActiveId,
        sensPiece: SENS_VENTE,
        debit: true,
      };
      this.mouvementClientReglement.tiersId = await this.getTiersId(this.infoClient.clientSelected,
        this.infoFacture.factureSelected);
      await this.getSoldeOfTiersId();
      this.dataTable = await this.getPieces(parameters,
        this.mouvementClientReglement, this.idRemiseBancaire);
      parameters.debit = false;
      parameters.excludeMouvementClientId = this.mouvementClientReglement.id;
      const objectFilter = {
        query: parameters,
        limit: NO_PAGINATION,
        SkipCount: 0,
        societeId: this.societeActiveId,
      };
      const response = await getAllByPiece(objectFilter);
      this.pieceAuCredit = response.data.result.items;
      this.pieceAuCredit.forEach((piece) => {
        piece.selected = false;
      });
      this.resteParPieceAuCredit = this.cumulParTypeDePiece(this.pieceAuCredit, false);
      this.otherCreditOpen = false;
    },
    getFactureASyncAndReloadClient: debounce(async function loadData() {
      this.infoClient.client = '';
      if (this.infoFacture.factureSelected
        && this.infoFacture.factureSelected.code === this.infoFacture.facture) {
        return;
      }
      this.infoFacture.factureSelected = null;

      if (!this.infoFacture.facture.length) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const tmp = await getAllFacture({
          query:
            {
              code: this.infoFacture.facture,
              societeId: this.societeActiveId,
              sousType: [SOUS_TYPE_NORMAL, SOUS_TYPE_ACOMPTE],
              type: TYPE_FACTURE,
              sens: SENS_VENTE,
              etat: [ETAT_ENREGISTRE],
              sansDonneesPresse: true,
            },
        });

        tmp.data.result.items.forEach(facture => {
          const annonceurs = facture.intervenants.reduce((accumulateur, valeurCourante) => {
            if (valeurCourante.annonceur === false) return accumulateur;
            if (accumulateur.length > 0) {
              return accumulateur + ', ' + valeurCourante.tiers.nomCommercial;
            }
            return valeurCourante.tiers.nomCommercial;
          }, '');
          facture.codeAnnonceur = facture.code + ' - ' + annonceurs;
        });
        this.dataFacture = tmp.data.result.items;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      this.infoFacture.factureSelected = null;
    }, 500),
    async selectFacture(facture) {
      if (facture === null) return;

      this.infoFacture.factureSelected = facture;
      if (facture.intervenants !== null) {
        facture.intervenants.forEach(intervenant => {
          if (intervenant.payeur !== true) return;
          this.infoClient.clientSelected = intervenant.tiers;
        });
      }
      this.totalLetterage = 0;
      this.mouvement = [];
      this.dataTable = [];
      const param = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        factureId: facture.id,
        brouillard: false,
        societeId: this.societeActiveId,
        sensPiece: SENS_VENTE,
        debit: true,
      };
      this.mouvementClientReglement.tiersId = await this.getTiersId(this.infoClient.clientSelected,
        this.infoFacture.factureSelected);
      this.mouvementClientReglement.ligneRemiseBancairePseudoEntity.emetteur = this.infoClient
        .clientSelected.nomCommercial;
      await this.getSoldeOfTiersId();

      this.dataTable = await this.getPieces(param,
        this.mouvementClientReglement, this.idRemiseBancaire);
      let cumulSoldes = 0.0;
      if (this.dataTable !== null && this.dataTable.length > 0) {
        this.dataTable.forEach(piece => {
          cumulSoldes += this.getSoldePiece(piece);
        });
      }
      param.debit = false;
      param.excludeMouvementClientId = this.mouvementClientReglement.id;
      const objectFilter = {
        query: param,
        limit: NO_PAGINATION,
        SkipCount: 0,
        societeId: this.societeActiveId,
      };
      const response = await getAllByPiece(objectFilter);
      this.pieceAuCredit = response.data.result.items;
      this.pieceAuCredit.forEach((piece) => {
        piece.selected = false;
      });
      this.resteParPieceAuCredit = this.cumulParTypeDePiece(this.pieceAuCredit, false);
      this.checkMontantTtc(cumulSoldes);
      this.otherCreditOpen = false;
    },
    async getPieces(query, mouvementClientReglement, remiseBancaireId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const objectFilter = {
          query: query,
          limit: NO_PAGINATION,
          SkipCount: 0,
          societeId: this.societeActiveId,
          orderBy: 'datePiece',
        };
        const response = await getAllByPiece(objectFilter);
        preparationListePieces(response.data.result.items,
          mouvementClientReglement, remiseBancaireId);
        this.mouvement = response.data.result.items;

        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      return this.mouvement;
    },
    async sauvegardeReglement() {
      this.error = false;
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      if (this.mouvementClientReglement.credit === undefined
        || this.mouvementClientReglement.credit === null
        || this.mouvementClientReglement.credit === 0.0) {
        this.messages.push({
          message: 'remiseBancaire.ajoutReglement.montantObligatoire',
        });
      }
      if (!this.infoClient.clientSelected) {
        this.messages.push({
          message: 'remiseBancaire.ajoutReglement.clientObligatoire',
        });
      }
      if (this.dataTable !== null && this.dataTable.length > 0) {
        const escompteUtilise = this.dataTable.find(piece => {
          return piece.escompteApplicable === true;
        });
        const creditSelectionne = this.pieceAuCredit.find((piece) => {
          return piece.selected === true;
        });
        if (escompteUtilise && creditSelectionne) {
          this.messages.push({
            message: 'remiseBancaire.ajoutReglement.pasEscompteEtCreditSelected',
          });
        }
      }
      if (this.messages.length > 0) {
        this.error = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.mouvementClientReglement.dateMouvement = cloneDeep(
          formatIsoDate(this.dateReglementTmp),
        );
        this.mouvementClientReglement.ligneRemiseBancairePseudoEntity.dateEffet = cloneDeep(
          formatIsoDate(this.dateEffetTmp),
        );
        let response = null;
        if (!this.isModification) {
          this.mouvementClientReglement.remiseBancaireId = this.idRemiseBancaire;
          this.mouvementClientReglement.tiersId = this.infoClient.clientSelected.id;
          response = await createReglement(this.toReglement(this.mouvementClientReglement,
            this.dataTable));

          this.reglementIsSave = response.data.result.id;
          this.mouvementClientReglement.id = response.data.result.id;
        } else {
          if (this.mouvementClientReglement.credit !== this.montantReglementInitial) {
            const lettragesAsupprimer = {
              lettrages: this.mouvementClientReglement.lettrages.map(l => {
                return {
                  ...l,
                  montant: 0,
                };
              }),
            };
            await sauvegarde(lettragesAsupprimer);
          }
          response = await updateReglement(this.toReglement(this.mouvementClientReglement,
            this.dataTable));
        }
        const avoirAuCreditSelected = [];
        const reglementsSelected = [];
        this.pieceAuCredit.forEach((piece) => {
          if (piece.selected === true) {
            switch (piece.pieceType) {
              case mouvementClientConf.AVOIR:
                avoirAuCreditSelected.push(piece);
                break;
              case mouvementClientConf.REGLEMENT:
                reglementsSelected.push(piece);
                break;
              default:
                break;
            }
          }
        });
        let tousLettrages = [];

        avoirAuCreditSelected.forEach((avoir) => {
          avoir.mouvementsClients.forEach(mcAvoir => {
            const lettragesAvoir = gestionLettrages(this.dataTable, mcAvoir, true, false);
            if (lettragesAvoir !== null && lettragesAvoir.length > 0) {
              tousLettrages = tousLettrages.concat(cloneDeep(lettragesAvoir));
            }
          });
        });
        reglementsSelected.forEach((reglement) => {
          reglement.mouvementsClients.forEach(mcReglement => {
            const lettragesAutresReglements = gestionLettrages(this.dataTable, mcReglement, true,
              false);
            if (lettragesAutresReglements !== null && lettragesAutresReglements.length > 0) {
              tousLettrages = tousLettrages.concat(cloneDeep(lettragesAutresReglements));
            }
          });
        });
        const tmp = await getMouvementClient(this.mouvementClientReglement.id);
        this.mouvementClientReglement = tmp.data.result;
        const lettrages = gestionLettrages(this.dataTable, this.mouvementClientReglement, false,
          true);
        if (lettrages !== null && lettrages.length > 0) {
          tousLettrages = tousLettrages.concat(cloneDeep(lettrages));
        }

        if (tousLettrages !== null && tousLettrages.length > 0) {
          const allLettrages = {
            lettrages: tousLettrages,
          };
          await sauvegarde(allLettrages);
        }
        if (this.isModification) {
          messageSucces(this.$t('remiseBancaire.messages.successEditReglement'));
        } else messageSucces(this.$t('remiseBancaire.messages.successAddReglement'));
        this.error = false;
        if (this.addOther && !this.isModification) {
          await this.reLoadValue();
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        this.$router.go(-1);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          if (this.reglementIsSave !== null) {
            this.$router.push({
              name: 'm.bodac.remises_bancaires-editionPiece',
              params: { idReglement: this.reglementIsSave, erreur: true },
            });
            return;
          }
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        throw (e);
      }
    },
    async calculateSolde(piece) {
      if (piece.inputAffecte === null) {
        piece.inputAffecte = 0;
        piece.solde = piece.soldeSave;
      }
      if (piece.inputAffecte >= piece.soldeSave) {
        piece.inputAffecte = piece.soldeSave;
        piece.solde = 0;
      } else {
        let soldeSave = piece.soldeSave;
        if (soldeSave === undefined) {
          soldeSave = 0;
        }
        piece.solde = soldeSave - piece.inputAffecte;
      }
      await this.calculAllLettrage();
      if (this.mouvementClientReglement.credit === null) return;
      this.mouvementClientReglement.resteALettrer = this.cumulDesReglements
        - this.totalLetterage;
      ventilationAutomatique(piece);
    },
    async assignAmount(piece) {
      if (this.mouvementClientReglement.credit === null
        || this.mouvementClientReglement.resteALettrer === 0) return;
      if (this.totalLetterage > this.cumulDesReglements
        && piece.inputAffecte === 0) { return; }

      if (piece.escompteApplicable === true) {
        piece.inputAffecte = Math.min(piece.restantALettrerTtc - piece.montantEscompte,
          this.mouvementClientReglement.resteALettrer);
        piece.solde = 0;
      } else if (this.getSoldePiece(piece) > (this.cumulDesReglements
          - this.totalLetterage)) {
        piece.inputAffecte += this.cumulDesReglements - this.totalLetterage;
        piece.solde -= this.cumulDesReglements - this.totalLetterage;
      } else {
        piece.inputAffecte = piece.restantALettrerTtc;
        piece.solde = 0;
      }

      await this.calculAllLettrage();
      this.mouvementClientReglement.resteALettrer = this.cumulDesReglements
        - this.totalLetterage;
      ventilationAutomatique(piece);
    },
    showPopupDetail(piece) {
      if (piece === null) return;
      this.piecePourDetail = piece;
      this.displayPopupDetail = true;
    },
    async reLoadValue() {
      this.infoClient.client = '';
      this.infoClient.clientSelected = null;
      this.infoFacture.facture = '';
      this.infoFacture.factureSelected = null;
      this.mouvementClientReglement = getEmptyMouvementClient();
      this.mouvementClientReglement.remiseBancaireId = this.idRemiseBancaire;
      const tmp = await getRemiseBancaire(this.mouvementClientReglement.remiseBancaireId);
      this.remiseBancaire = tmp.data.result;
      this.dateReglementTmp = gestionDateBase(this.remiseBancaire.dateRemise);
      this.dateEffetTmp = null;
      this.dataTable = [];
      this.pieceAuCredit = [];
      this.otherCreditOpen = false;
      this.resteParPieceAuCredit = [];
      this.selectedParPieceAuCredit = [];
    },
    modificationAutoComplete(dataClient) {
      this.infoClient.dataAutoComplete = [];
      dataClient.items.forEach((client) => {
        client.nomCommercialAvecVille = client.code + ' - ' + client.nomCommercial + ' - '
          + adressFullStringGetter(client.adressePostale, false);
        if (client.compteComptable) {
          client.nomCommercialAvecVille += ' - ' + client.compteComptable;
        }
        this.infoClient.dataAutoComplete.push(client);
      });
    },
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationReglement(response, this.messages);
      validationGeneral(this.$i18n, response, this.champsVide,
        this.messages, this.messagesChampsVide, translate);
      this.error = true;
    },
    annuler() {
      this.$router.go(-1);
    },
    formatDate(data) {
      return formatDate(data);
    },
    calculAllLettrage() {
      this.totalLetterage = 0;
      this.dataTable.forEach((line) => {
        line.inputAffecte = parseFloat(calculArrondi(line.inputAffecte));
        this.totalLetterage += parseFloat(line.inputAffecte);
      });
      return this.totalLetterage;
    },
    async chargerDonneesModification() {
      this.infoClient.client = miseEnFormeAddresseClient(this.mouvementClientReglement);
      this.dateEffetTmp = gestionDateBase(
        this.mouvementClientReglement.ligneRemiseBancairePseudoEntity.dateEffet,
      );
      this.dateReglementTmp = gestionDateBase(
        this.mouvementClientReglement.dateMouvement,
      );
      const idsMouvementClientLettres = [];
      if (this.mouvementClientReglement.lettrages !== null) {
        this.mouvementClientReglement.lettrages.forEach(lettrage => {
          if (lettrage.mouvementClient1Id !== this.mouvementClientReglement.id) {
            idsMouvementClientLettres.push(lettrage.mouvementClient1Id);
          }
          if (lettrage.mouvementClient2Id !== this.mouvementClientReglement.id) {
            idsMouvementClientLettres.push(lettrage.mouvementClient2Id);
          }
        });
      }
      if (this.mouvementClientReglement.mouvementClientEnfants !== undefined
        && this.mouvementClientReglement.mouvementClientEnfants !== null) {
        this.mouvementClientReglement.mouvementClientEnfants.forEach(mcEscompte => {
          if (mcEscompte.lettrages === null) return;
          mcEscompte.lettrages.forEach(lettrageEscompte => {
            if (lettrageEscompte.mouvementClient1Id !== mcEscompte.id) {
              idsMouvementClientLettres.push(lettrageEscompte.mouvementClient1Id);
            }
            if (lettrageEscompte.mouvementClient2Id !== mcEscompte.id) {
              idsMouvementClientLettres.push(lettrageEscompte.mouvementClient2Id);
            }
          });
        });
      }

      let parameters = {
        ids: idsMouvementClientLettres,
        tiersId: this.mouvementClientReglement.tiersId,
        societeId: this.societeActiveId,
        brouillard: false,
        debit: true,
      };
      this.dataTable = await this.getPieces(parameters, this.mouvementClientReglement,
        this.idRemiseBancaire);
      parameters = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        brouillard: false,
        tiersId: this.mouvementClientReglement.tiersId,
        societeId: this.societeActiveId,
        debit: true,
      };
      const piecesRestantALettrer = await this.getPieces(parameters,
        this.mouvementClientReglement, this.idRemiseBancaire);
      piecesRestantALettrer.forEach(pieceALettrer => {
        let trouve = false;
        if (this.dataTable !== null) {
          this.dataTable.forEach(piece => {
            if (piece.pieceId === pieceALettrer.pieceId
              && piece.pieceType === pieceALettrer.pieceType) {
              trouve = true;
            }
          });
        }
        if (!trouve) this.dataTable.push(pieceALettrer);
      });
      if (this.mouvementClientReglement.mouvementClientEnfants !== null) {
        this.mouvementClientReglement.mouvementClientEnfants.forEach(mvtEscompte => {
          if (mvtEscompte.typeDePiece !== mouvementClientConf.ESCOMPTE) return;
          this.dataTable.forEach(piece => {
            if (piece.pieceId !== mvtEscompte.factureId) return;
            piece.montantEscompte = mvtEscompte.credit;
            piece.escompteApplicable = true;
          });
        });
      }
      this.dataTable.forEach(reglement => {
        this.calculateSolde(reglement);
      });
      await this.calculAllLettrage();
      await this.getSoldeOfTiersId();

      parameters.debit = false;
      parameters.excludeMouvementClientId = this.mouvementClientReglement.id;
      const objectFilter = {
        query: parameters,
        limit: NO_PAGINATION,
        SkipCount: 0,
        societeId: this.societeActiveId,
      };
      const response = await getAllByPiece(objectFilter);
      this.pieceAuCredit = response.data.result.items;
      this.pieceAuCredit.forEach((piece) => {
        piece.selected = false;
      });
      this.resteParPieceAuCredit = this.cumulParTypeDePiece(this.pieceAuCredit, false);
    },
    nomClient() {
      if (this.infoClient === null || this.infoClient.clientSelected === null
        || this.infoClient.clientSelected.nomCommercial === null) {
        return '';
      }

      return this.infoClient.clientSelected.nomCommercial;
    },
    getSoldePiece(piece) {
      if (piece === null) return 0.0;
      if (piece.escompteApplicable === true) {
        return piece.restantALettrerTtc - piece.inputAffecte - piece.montantEscompte;
      }
      return piece.restantALettrerTtc - piece.inputAffecte;
    },
    toReglement(mouvementClient, pieces) {
      const reglement = {
        id: mouvementClient.id,
        dateReglement: cloneDeep(mouvementClient.dateMouvement),
        montantTtc: mouvementClient.credit,
        emetteur: mouvementClient.ligneRemiseBancairePseudoEntity.emetteur,
        referenceReglement: mouvementClient.ligneRemiseBancairePseudoEntity.referenceReglement,
        dateEffet: cloneDeep(mouvementClient.ligneRemiseBancairePseudoEntity.dateEffet),
        remiseBancaireId: this.idRemiseBancaire,
        tiersId: this.infoClient.clientSelected.id,
        escomptes: this.toEscomptes(pieces, mouvementClient.mouvementClientEnfants),
      };
      return reglement;
    },
    toEscomptes(pieces, mouvementsClientsEscomptes) {
      if (pieces === null || pieces.length === 0) return null;
      const escomptes = [];
      pieces.forEach(piece => {
        if (mouvementsClientsEscomptes !== undefined && mouvementsClientsEscomptes.length > 0) {
          const index = mouvementsClientsEscomptes.findIndex((mvtEscompte) => {
            return piece.pieceId === mvtEscompte.factureId;
          });
          if (index !== -1) {
            escomptes.push({
              mouvementClientId: mouvementsClientsEscomptes[index].id,
              factureId: piece.pieceId,
              factureCode: piece.facture.code,
              montant: piece.montantEscompte,
              estApplicable: piece.escompteApplicable,
            });
            return;
          }
        }
        if (piece.escompteApplicable === false
          || piece.pieceType !== mouvementClientConf.FACTURE) return;
        escomptes.push({
          factureId: piece.pieceId,
          factureCode: piece.facture.code,
          montant: piece.montantEscompte,
          estApplicable: piece.escompteApplicable,
        });
      });
      return escomptes;
    },
    getUrlPiece(piece) {
      return {
        name: 'c.bodac.factures',
        params: { id: piece.pieceId },
      };
    },
    pieceAsLink(piece) {
      return piece.pieceType === mouvementClientConf.FACTURE
        || piece.pieceType === mouvementClientConf.AVOIR
        || piece.pieceType === mouvementClientConf.ACOMPTE;
    },
    gererSaisieEscompte(piece) {
      if (piece.escompteApplicable === false) {
        ventilationAutomatique(piece);
        return;
      }
      const soldeTemporaire = this.getSoldePiece(piece);

      if (soldeTemporaire < 0 && Math.abs(soldeTemporaire) < Math.abs(piece.inputAffecte)) {
        piece.inputAffecte += soldeTemporaire;
      }
      if (soldeTemporaire < 0 && Math.abs(soldeTemporaire) > Math.abs(piece.inputAffecte)) {
        piece.inputAffecte = 0;
      }
      ventilationAutomatique(piece);
    },
    isFacture(piece) {
      if (piece === null) return false;
      return piece.pieceType === mouvementClientConf.FACTURE;
    },
    cumulParTypeDePiece(pieces, selectedOnly) {
      const listeRetour = [];
      if (pieces === undefined || pieces === null || pieces.length === 0) return listeRetour;
      pieces.forEach((piece) => {
        if (selectedOnly === false || (selectedOnly === true && piece.selected === true)) {
          const cumulPiece = listeRetour.find((element) => {
            return element.pieceType === piece.pieceType;
          });
          if (cumulPiece === undefined) {
            listeRetour.push({
              pieceType: piece.pieceType,
              restantALettrerTtc: piece.restantALettrerTtc,
            });
          } else {
            cumulPiece.restantALettrerTtc += piece.restantALettrerTtc;
          }
        }
      });
      return listeRetour;
    },
    selectCredit() {
      this.selectedParPieceAuCredit = this.cumulParTypeDePiece(this.pieceAuCredit, true);
    },
    atLeast5PieceAuCredit() {
      if (this.pieceAuCredit === undefined || this.pieceAuCredit === null
        || this.pieceAuCredit.length < 5) return false;
      return true;
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getColorOfSolde() {
      if (!this.checkPermissions(this.permsTiers.lecture)) return 'text-access-no-permission';
      if (this.soldeTiersId < 0) return 'has-text-danger';
      if (this.soldeTiersId > 0) return 'has-text-success';
      return 'has-text-default';
    },
    getIcon() {
      if (this.totalLetterage.toFixed(2) > this.cumulDesReglements.toFixed(2)) return 'alert';
      if (this.totalLetterage.toFixed(2) === this.cumulDesReglements.toFixed(2)
        && this.cumulDesReglements !== 0) {
        return 'check-circle';
      }
      return '';
    },
    getClassColor() {
      if (this.cumulDesReglements === null && this.totalLetterage !== 0) return 'has-text-danger';
      if (this.totalLetterage.toFixed(2) > this.cumulDesReglements.toFixed(2)
        && this.cumulDesReglements !== 0) return 'has-text-danger';
      return '';
    },
    remiseValidee() {
      return this.remiseBancaire.etat === remiseConf.VALIDE;
    },
    isModification() {
      return (this.idReglement !== null && this.idReglement !== undefined);
    },
    getType() {
      if (this.totalLetterage.toFixed(2) > this.cumulDesReglements.toFixed(2)) return 'is-warning';
      if (this.totalLetterage.toFixed(2) === this.cumulDesReglements.toFixed(2)
        && this.cumulDesReglements !== 0) return 'is-success';
      return '';
    },
    getTitre() {
      return !this.isModification ? this.$t('remiseBancaire.ajoutReglement.titre')
        : this.$t('remiseBancaire.ajoutReglement.titreModification');
    },
    getSousTitre() {
      return !this.isModification ? this.$t('remiseBancaire.ajoutReglement.titre')
        : this.$t('remiseBancaire.ajoutReglement.titreModification');
    },
    breadcrumb() {
      const output = [
        { title: this.$t('remiseBancaire.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('remiseBancaire.titre'), route: { name: 'l.bodac.remises_bancaires' }, isActive: false },
        {
          title: formatCodeRemiseBancaire(this.remiseBancaire.num,
            this.remiseBancaire.nom, SENS_VENTE),
          route: { name: 'c.bodac.remises_bancaires', params: { id: this.idRemiseBancaire } },
          isActive: false,
        },
        { title: this.getTitre, isActive: true },
      ];
      return output;
    },
    existResteParPieceAuCredit() {
      return this.resteParPieceAuCredit !== null
        && this.resteParPieceAuCredit !== undefined
        && this.resteParPieceAuCredit.length !== 0;
    },
    existResteParPieceSelectedAuCredit() {
      return this.selectedParPieceAuCredit !== null
        && this.selectedParPieceAuCredit !== undefined
        && this.selectedParPieceAuCredit.length !== 0;
    },
    cumulDesReglements() {
      let cumul = 0;
      cumul += this.mouvementClientReglement.credit;
      if (this.selectedParPieceAuCredit === undefined || this.selectedParPieceAuCredit === null
        || this.selectedParPieceAuCredit.length === 0) {
        return cumul;
      }
      this.selectedParPieceAuCredit.forEach((el) => {
        cumul += el.restantALettrerTtc;
      });
      return cumul;
    },
    getDifference() {
      return (this.cumulDesReglements.toFixed(2) - this.totalLetterage.toFixed(2));
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.idRemiseBancaire = this.$route.params.idRemiseBancaire;
    this.idReglement = this.$route.params.idReglement;
    if (this.$route.params.erreur === true) {
      this.error = true;
      this.messages.push({
        message: 'remiseBancaire.ajoutReglement.montantInferieur',
      });
    }
    try {
      if (this.idRemiseBancaire === null || this.idRemiseBancaire === undefined) {
        const reglementData = await getReglement(this.$route.params.idReglement);
        this.idRemiseBancaire = reglementData.data.result.remiseBancaireId;
        this.montantReglementInitial = reglementData.data.result.credit;
      }
      const tmp = await getRemiseBancaire(this.idRemiseBancaire);
      this.remiseBancaire = tmp.data.result;

      this.dateReglementTmp = gestionDateBase(this.remiseBancaire.dateRemise);

      if (this.isModification) {
        const tmp = await getMouvementClient(this.idReglement);
        this.mouvementClientReglement = tmp.data.result;
        this.infoClient.clientSelected = this.mouvementClientReglement.tiers;
        await this.chargerDonneesModification();
        this.montantReglementInitial = this.mouvementClientReglement.credit;
        this.setInformationPage(this.$t('pageGescom.remiseBancaire.modififcationReglement'));
      } else {
        this.setInformationPage(this.$t('pageGescom.remiseBancaire.creationReglement'));
      }
      this.mouvementClientReglement.remiseBancaireId = this.idRemiseBancaire;

      loadingComponent.close();
    } catch (e) {
      if (e.response.data.error) {
        this.loadError(e.response);
      } else {
        messageErreur(this.$i18n);
      }
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
